import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'outline',
    fontSize: '2xs',
    height: 'auto',
    lineHeight: 'inherit',
    borderRadius: 'base',
    px: '3',
    py: '1',
    sx: { '&:active, &[data-active:"true"]': {} },
  },
};
